import AssetUpload from 'components/AssetUpload';
import ImageSpecifications from 'components/ImageSpecifications';
import SlugInput from '../../../components/form-items/SlugInput';
import useParentCategoriesSelect from '../../../hooks/useParentCategoriesSelect';
import { Card, Form, Input, Select } from 'antd';
import { CreateLayout } from 'components/layout/layout/CreateLayout';
import { EcommerceIconComponent } from 'assets/icons/ecommerce';
import { IProductCategory } from 'interfaces/product_categories';
import { PageHeader } from 'components/professor_area/PageHeader';
import { applyImageSizeRestriction } from 'utils/apply-image-size-restriction';
import { shouldApplyImageRestrictions } from 'utils/should-apply-image-restrictions';
import { useForm } from '@refinedev/antd';

export const ProductCategoryCreate = () => {
  const { formProps, saveButtonProps } = useForm<IProductCategory>();
  return (
    <CreateLayout saveButtonProps={saveButtonProps} title="Criar categoria">
      <PageHeader title="Criar categoria" icon={EcommerceIconComponent} />

      <Card>
        <Form {...formProps} layout="vertical">
          <ImageSpecifications
            title="Especificações Card"
            size="500kb"
            format="jpeg/jpg/png"
          />
          <Form.Item
            label={!shouldApplyImageRestrictions() ? 'Card' : ''}
            name={['media', 'card_image']}
          >
            <AssetUpload
              accept="image/png, image/jpeg"
              type="product_category"
              maxSize={applyImageSizeRestriction('card')}
            />
          </Form.Item>
          <Form.Item
            label="Nome"
            name="name"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input />
          </Form.Item>

          <SlugInput />
          <Form.Item
            label="Nome Curto"
            name="short_name"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Descrição"
            name="description"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input.TextArea />
          </Form.Item>
          <Form.Item
            className="w-1/2"
            label="Categoria pai"
            name="parent_category_id"
          >
            <Select
              allowClear
              onDeselect={() =>
                formProps.form?.setFieldsValue({
                  parent_category_id: null
                })
              }
              {...useParentCategoriesSelect({})}
              placeholder="Caso haja, selecione a categoria pai"
            />
          </Form.Item>
        </Form>
      </Card>
    </CreateLayout>
  );
};
